<template>
  <div id="data-edit-tab-info">

    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full mt-4">
        <label class="vs-input--label">Template</label>
        <v-select :options="optionNotificationTemplate" :reduce="title => title.id" label="title" @change="selectTemplate($event)" @input="selectTemplate($event)" v-model="data_local.notification_message_id" name="notification_message_id"/>
        <span class="text-danger text-sm"  v-show="errors.has('notification_message_id')">{{ errors.first('notification_message_id') }}</span>

        <vs-input class="w-full mt-4" label="Title" v-model="data_local.title" type="title"  v-validate="'required'" name="title" />
        <span class="text-danger text-sm"  v-show="errors.has('title')">{{ errors.first('title') }}</span>

        <vs-textarea height="200px"  class="w-full mt-4" label="Message" v-model="data_local.message" v-validate="'required'" name="message" />
        <span class="text-danger text-sm"  v-show="errors.has('message')">{{ errors.first('message') }}</span>
      </div>

      <div class="vx-col md:w-1/2 w-full mt-4">
        <!-- <div class="mt-4">
          <label class="vs-input--label">User Email</label>
          <v-select multiple :options="optionUser" :reduce="email => email.id" label="email" v-validate="'required'" v-model="data_local.user_id" name="user_id"/>
          <span class="text-danger text-sm"  v-show="errors.has('user_id')">{{ errors.first('user_id') }}</span>
        </div> -->

        <label class="vs-input--label">Repeat</label>
        <div class="vx-row">
          <div class="vx-col w-full">
              <div class="flex flex-wrap mt-1 mb-6">
                <vs-radio  v-model="data_local.isRepeat" vs-value="1" class="mr-4 mb-2">Yes</vs-radio >
                <vs-radio  v-model="data_local.isRepeat" vs-value="2" class="mr-4 mb-2">No</vs-radio >
              </div>

              <div v-if="data_local.isRepeat == 1">                
                <div class="mt-4">
                  <label class="vs-input--label">Start Date and Time</label><br>
                  <flat-pickr :config="configETA" v-model="data_local.start_date" class="mr-2 mb-2 flatpickr-input w-full" name="start_date" v-validate="'required'" />
                  <span class="text-danger text-sm"  v-show="errors.has('start_date')">{{ errors.first('start_date') }}</span>
                </div>

                <div class="mt-4" v-if="data_local.isRepeat == 1">
                  <label class="vs-input--label">Repeats On</label>
                  <v-select :options="optionNotificationRepeat" :reduce="label => label.id" label="label" v-validate="'required'" v-model="data_local.repeat_type" name="repeat_type"/>
                  <span class="text-danger text-sm"  v-show="errors.has('repeat_type')">{{ errors.first('repeat_type') }}</span>
                </div>

                <!-- <div class="flex flex-wrap mt-4" v-if="data_local.repeat_type == 1">
                  <vs-button radius color="dark" type="border" icon-pack="feather" class="mr-2" style="height:40px;width:40px;" v-model="data_local.recurDay">S</vs-button>
                  <vs-button radius color="dark" type="border" icon-pack="feather" class="mr-2" style="height:40px;width:40px;" v-model="data_local.recurDay">M</vs-button>
                </div> -->

                  <ul :class="{'flex':true, 'flex-wrap':true, 'mt-8':true, 'p-2':true, 'danger':repeatDayErr}" v-if="data_local.repeat_type == 1">
                    <li>
                      <vs-checkbox v-model="data_local.repeatDay" vs-value="0">Sunday</vs-checkbox>
                    </li>
                    <li>
                      <vs-checkbox v-model="data_local.repeatDay" vs-value="1">Monday</vs-checkbox>
                    </li>
                    <li>
                      <vs-checkbox v-model="data_local.repeatDay" vs-value="2">Tuesday</vs-checkbox>
                    </li>
                    <li>
                      <vs-checkbox v-model="data_local.repeatDay" vs-value="3">Wednesday</vs-checkbox>
                    </li>
                    <li>
                      <vs-checkbox v-model="data_local.repeatDay" vs-value="4">Thursday</vs-checkbox>
                    </li>
                    <li>
                      <vs-checkbox v-model="data_local.repeatDay" vs-value="5">Friday</vs-checkbox>
                    </li>
                    <li>
                      <vs-checkbox v-model="data_local.repeatDay" vs-value="6">Saturday</vs-checkbox>
                    </li>
                  </ul>

                  <div class="mt-5">
                    <label class="vs-input--label">End Date and Time</label><br>
                    <flat-pickr :config="configETA" v-model="data_local.end_date" class="mr-2 mb-2 flatpickr-input w-full" name="end_date" v-validate="'required'"/>
                    <span class="text-danger text-sm"  v-show="errors.has('end_date')">{{ errors.first('end_date') }}</span>
                  </div>
              </div>
          </div>          
        </div>

        <vs-divider class="mt-8"></vs-divider>

        <!-- <pre> {{ selected }} </pre> -->
      </div>
    </div>

    <!-- Content Row -->
    <div class="vx-row">      
      <div class="vx-col w-1/2">
        <div class="flex items-end md:mt-8 mb-4">
          <feather-icon icon="UserIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">Recipients Category</span>
        </div>
        <vs-tabs>
          <vs-tab label="Resident" @click="selectRecipientType(1)">
            <vs-table multiple v-model="selected" @selected="handleSelected" pagination max-items="10" search :data="optionUser" :class="{'mt-4':true, 'danger':selectedErr}">
              <template slot="thead">
                <vs-th style="padding:0px; font-weight: normal;">Select All</vs-th>
                <vs-th sort-key="unit_id">Unit Number</vs-th>
                <vs-th sort-key="id">User Type</vs-th>
                <vs-th sort-key="first_name">First</vs-th>
                <vs-th sort-key="last_name">Last</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  
                  <vs-td></vs-td>
                  <vs-td :data="data[indextr].unit_residents[indextr]">
                    {{ data[indextr].unit_residents[0] === undefined ? 0 : data[indextr].unit_residents[0].unit.number }}
                  </vs-td>

                  <vs-td :data="data[indextr].user_role.name">
                    {{ data[indextr].user_role.name }}
                  </vs-td>

                  <vs-td :data="data[indextr].first_name">
                    {{ data[indextr].first_name }}
                  </vs-td>

                  <vs-td :data="data[indextr].last_name">
                    {{ data[indextr].last_name }}
                  </vs-td>

                </vs-tr>
              </template>
            </vs-table>    
          </vs-tab>

          <vs-tab label="User Type" @click="selectRecipientType(2)">
            <vs-table multiple v-model="selected" @selected="handleSelected" pagination max-items="10" search :data="optionUserType" :class="{'mt-4':true, 'danger':selectedErr}">
              <template slot="thead">
                <vs-th style="padding:0px; font-weight: normal;">Select All</vs-th>
                <vs-th sort-key="parent_name">Parent User Type</vs-th>
                <vs-th sort-key="name">User Type</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  
                  <vs-td></vs-td>
                  <vs-td :data="data[indextr].parent_name">
                    {{ data[indextr].parent_name[0].name === undefined ? data[indextr].parent_name : data[indextr].parent_name[0].name }}
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                </vs-tr>
              </template>
            </vs-table>    
          </vs-tab>
        </vs-tabs>

      </div>
      <div class="vx-col w-1/2">
        <div class="flex items-end md:mt-8 mb-4">
          <feather-icon icon="UsersIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">Selected Recipient</span>
        </div>
        <vs-tabs>
          <vs-tab label="Review recipients">
            <vs-table multiple v-model="selected" pagination max-items="10" search :data="selected" :class="{'mt-4':true, 'danger':selectedErr}">
              <template slot="thead">
                <vs-th style="padding:0px; font-weight: normal;">Select All</vs-th>
                <vs-th sort-key="user_type" v-if="data_local.recipient_type === 2">User Type</vs-th>
                <vs-th sort-key="email" v-if="data_local.recipient_type === 1">Email</vs-th>
                <vs-th sort-key="first_name" v-if="data_local.recipient_type === 1">First Name</vs-th>
                <vs-th sort-key="last_name" v-if="data_local.recipient_type === 1">Last Name</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  
                  <vs-td></vs-td>

                  <vs-td :data="data[indextr].name" v-if="data_local.recipient_type === 2">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td :data="data[indextr].email" v-if="data_local.recipient_type === 1">
                    {{ data[indextr].email }}
                  </vs-td>

                  <vs-td :data="data[indextr].first_name" v-if="data_local.recipient_type === 1">
                    {{ data[indextr].first_name }}
                  </vs-td>

                  <vs-td :data="data[indextr].last_name" v-if="data_local.recipient_type === 1">
                    {{ data[indextr].last_name }}
                  </vs-td>


                </vs-tr>
              </template>
            </vs-table>  
          </vs-tab>  
        </vs-tabs>
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="submit" :disabled="!validateForm">Send Notification</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import axios from '../../../../axios'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import common from '@/common'
const today = new Date()
var formatedD = common.formatDate(today)

export default {
  components: {
    vSelect,
    flatPickr
  },

  data () {    
    return {
      optionNotificationRepeat: [
        { label: 'Weekly',  id: 1 },
        { label: 'Monthly',  id: 2 },
        { label: 'Annual',  id: 3 },
      ],      
      configETA: {
        minuteIncrement: 1,
        minDate: new Date(),
        maxDate: null, 
        enableTime: true,
        dateFormat: 'Y-m-d H:i',
        // "disable": [
        //     function(date) {
        //         // return true to disable
        //         return (date.getDay() === 0 || date.getDay() === 6);
        //     }
        // ],
        // defaultDate: [new Date()]
      },
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        minTime: "8:00",
        maxTime: "17:00",
        time_24hr: true
      },
      configFromdateTimePicker: {
        minDate: new Date(),
        maxDate: null,        
        "disable": [
            function(date) {
                // return true to disable
                return (date.getDay() === 0 || date.getDay() === 6);

            }
        ]
      },
      configTodateTimePicker: {
        minDate: null,
        "disable": [
            function(date) {
                // return true to disable
                return (date.getDay() === 0 || date.getDay() === 6);

            }
        ]
      },

      selected: [],
      selectedErr: false,
      'tableList': [
        'vs-th: Component',
        'vs-tr: Component',
        'vs-td: Component',
        'thread: Slot',
        'tbody: Slot',
        'header: Slot'
      ],

      optionNotificationTemplate: [],
      optionUser: [],
      optionUserType: [],

      token: localStorage.usertoken,

      //notification
      data_local: {
        message: '',
        title: '',
        notification_message_id: null,
        isRepeat: 2,
        start_date: null,
        start_time: null,
        end_date: null,
        end_time: null,
        repeatDay: [],
        repeat_type: null,
        property_ref: '',
        recipient_type: 1
      },
      repeatDayErr: false,

      statusOptions: [
        { label: 'Active',  value: 'active' },
        { label: 'Blocked',  value: 'blocked' },
        { label: 'Deactivated',  value: 'deactivated' }
      ],
      roleOptions: [
        { label: 'Admin',  value: 'admin' },
        { label: 'User',  value: 'user' },
        { label: 'Staff',  value: 'staff' }
      ],
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {
    handleSelected(tr) {
      console.log('handleSelected(tr) ', tr)
      console.log('selected ', this.selected)
    },
    selectRecipientType(id) {
      this.selected = []
      this.data_local.recipient_type = id
      console.log('this.data_local.recipient_type ', this.data_local.recipient_type)
    },
    capitalize (str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length)
    },
    submit() {
      this.$validator.validateAll()
      .then(result => {
        if(result) {
          this.save_changes()
        }
      })
    },
    save_changes () {
      this.data_local.user_id = []
      this.data_local.start_time = this.data_local.start_date
      this.data_local.end_time = this.data_local.end_date

      if (this.data_local.repeat_type == 1 && this.data_local.repeatDay.length === 0) {
        this.$vs.notify({
          color: 'danger',
          title: 'Saving Data',
          text: 'Please select at least one day'
        })
        this.repeatDayErr = true
        return false
      }

      if (this.selected.length === 0) {
        this.$vs.notify({
          color: 'danger',
          title: 'Saving Data',
          text: 'Please select User Email'
        })
        this.selectedErr = true
        return false
      }

      for (var key in this.selected) {
        this.data_local.user_id.push(this.selected[key]['id'])
      }

      /* eslint-disable */
      if (!this.validateForm) return

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */

      this.data_local.property_ref = localStorage.selectedParentOrgRef
      this.data_local.createdAt = common.formatDate2(new Date())
      this.data_local.updatedAt = common.formatDate2(new Date())

      const editId = -1
      new Promise(async(resolve, reject)  => {
        try {    
          await axios.post(`/notification/save/${editId}`,
              { data: this.data_local }, 
              { headers: { 'Authorization': this.token } },
            )
            .then(res => {    
              if(res['data'] != 'access_denied' && res['data'] != '') {

                if(res['data']['message'] == 'success') {
                  this.$vs.notify({
                    color: 'success',
                    title: 'Data Saved',
                    text: 'The selected data was successfully saved'
                  })
                  this.$router.push({name:'app-notification-list'})
                } else {
                  this.$vs.notify({
                    color: 'danger',
                    title: 'Saving Data',
                    text: 'Something went wrong'
                  })
                }

              } else {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Error loading',
                  text: 'Something went wrong'
                })
                this.$router.push({name:'app-notification-list'})
              }

            })
            .catch(err => {
              this.$vs.notify({
                color: 'danger',
                title: 'Data Saving Error',
                text: 'The selected data was not saved'
              })
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }      

      }) 
    },
    reset_data () {
      //notification
      this.data_local['message'] = ''
      this.data_local['title'] = ''
      this.$vs.notify({
        color: 'orange',
        title: 'Data Edit',
        text: 'The selected Data data was reset'
      })
    },
    update_avatar () {
      // You can update avatar Here
      // For reference you can check dataList example
      // We haven't integrated it here, because data isn't saved in DB
    },
    async loadNotificationTemplate() {
      try {    
        var res = await axios.get(`/notificationTemplate/list`, {
            headers: { 'Authorization': this.token, 'property_ref': localStorage.selectedParentOrgRef }
        })

        this.optionNotificationTemplate = res['data']
      } catch(err) {
        reject(err.toString('utf8'));
      }  

      console.log('res maintenanceType ', this.optionNotificationTemplate)
    },
    selectTemplate(event) {
      var nt = this.optionNotificationTemplate
      console.log('event ', event)      
      console.log('optionNotificationTemplate ', this.optionNotificationTemplate)  
      var nnt = nt.filter(x => x.id === event);   
      console.log('nnt ', nnt)   

      this.data_local.title = nnt[0]['title']
      this.data_local.message = nnt[0]['message']
      // console.log('optionNotificationTemplate ', this.optionNotificationTemplate['event'][title])

    },
    loadUser () {
      var d = new Promise( async (resolve, reject)  => {
        try {    
          await axios.get(`/user/unit/all`, {
              headers: { 
                'Authorization': this.token, 
                'property_ref': localStorage.selectedParentOrgRef,
              }
            })
            .then(res => {     
              resolve(res['data'])
            })
            .catch(err => {
              reject(err.toString('utf8'));
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }  
      })

      d.then((res) => {
        console.log('res loadUser ', res)
        this.optionUser = res
      })
    },
    loadUserType () {
      var d = new Promise( async (resolve, reject)  => {
        try {    
          await axios.get(`/role/list/all`, {
              headers: { 
                'Authorization': this.token, 
                'property_ref': localStorage.selectedParentOrgRef,
              }
            })
            .then(res => {     
              resolve(res['data'])
            })
            .catch(err => {
              reject(err.toString('utf8'));
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }  
      })

      d.then((res) => {
        console.log('res loadUserType ', res)
        res.filter((r) => {
          r.parent_name = r.parent_id === 0 ? 'Main' : res.filter(x => r.parent_id === x.id)
        })
        this.optionUserType = res
      })
    },

    
  },
  created () {
    this.loadNotificationTemplate()
    this.loadUser()
    this.loadUserType()
  } 
}
</script>

<style>
  .danger {
    border: 1px solid red
  }
</style>